import { useEffect } from "react";

const StructuredData = ({ product }) => {
  useEffect(() => {
    if (!product) return;

    // Create structured data for the product
    const structuredData = {
      "@context": "https://schema.org/",
      "@type": "Product",
      name: `${product.Name} - ${product.FrameColor}`,
      description: `${product.FrameColor} ${
        product.Material || ""
      } eyewear from Aram EyeCare. Premium quality frames at affordable prices.`.trim(),
      image: [
        product.ImageUrl1,
        product.ImageUrl2,
        product.ImageUrl3,
        product.ImageUrl4,
      ].filter(Boolean),
      brand: {
        "@type": "Brand",
        name: "Aram EyeCare",
      },
      offers: {
        "@type": "Offer",
        url: window.location.href,
        priceCurrency: "INR",
        price: product.Cost,
        availability:
          product.Availability === "In Stock"
            ? "https://schema.org/InStock"
            : "https://schema.org/OutOfStock",
        seller: {
          "@type": "Organization",
          name: "Aram EyeCare",
        },
      },
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: "4.5",
        reviewCount: "127",
      },
      category: "Eyewear",
      color: product.FrameColor,
      material: product.Material,
      productID: product.ProductID,
    };

    // Remove existing structured data script if any
    const existingScript = document.querySelector(
      'script[type="application/ld+json"]'
    );
    if (existingScript) {
      existingScript.remove();
    }

    // Add new structured data script
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);

    // Cleanup function
    return () => {
      const scriptToRemove = document.querySelector(
        'script[type="application/ld+json"]'
      );
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [product]);

  return null; // This component doesn't render anything
};

export default StructuredData;
